import classNames from 'classnames';
import InputGroup, { InputGroupOption, InputGroupProps } from '@alltrails/shared/denali/components/InputGroup';
import Checkbox, { CheckboxProps } from '@alltrails/shared/denali/components/Checkbox';
import MoreInfoLabel from '@alltrails/shared/components/forms/MoreInfoLabel';
import useIsMobile from '@alltrails/shared/hooks/useIsMobile';
import * as styles from './styles/styles.module.scss';

export type CheckboxWithIconOption = InputGroupOption & {
  id: string;
  selected: CheckboxProps['selected'];
  testId: string;
  moreInfo?: {
    title: React.ReactNode;
    content: React.ReactNode;
  };
};

export type CheckboxGroupWithIconProps = {
  className?: string;
  disabled?: boolean;
  errorText?: string;
  labelText?: string;
  onChange: (id: CheckboxWithIconOption['id'], selected: boolean) => void;
  options: CheckboxWithIconOption[];
  size?: CheckboxProps['size'];
  testId: string;
  verticalAlignment?: CheckboxProps['verticalAlignment'];
  useColumns?: boolean;
};

/**
 * @deprecated Use Denali CheckboxGroup instead. CheckboxGroups typically should not have inline trailing icons.
 */
const CheckboxGroupWithIcon = ({
  className,
  disabled,
  errorText,
  labelText,
  onChange,
  options,
  size = 'md',
  testId,
  verticalAlignment,
  useColumns
}: CheckboxGroupWithIconProps): JSX.Element => {
  const isMobile = useIsMobile();

  const renderInput: InputGroupProps<CheckboxWithIconOption>['renderInput'] = ({ id, selected, testId: optionTestId, moreInfo }, labelElement) => (
    <div className={classNames(styles.checkboxContainer, useColumns && styles.columnSection, isMobile && styles.mobile)} key={id}>
      <Checkbox
        disabled={disabled}
        id={id}
        labelElement={labelElement}
        onChange={(checked: boolean) => {
          onChange(id, checked);
        }}
        selected={selected}
        size={size}
        testId={optionTestId}
        verticalAlignment={verticalAlignment}
      />
      {moreInfo && <MoreInfoLabel moreInfo={moreInfo} />}
    </div>
  );

  return (
    <InputGroup
      className={classNames(className, useColumns && styles.containerColumns)}
      disabled={disabled}
      errorText={errorText}
      labelText={labelText}
      options={options}
      renderInput={renderInput}
      size={size}
      testId={testId}
      type="checkbox"
    />
  );
};

export default CheckboxGroupWithIcon;
